// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3m-8k","image":"styles_image__0P7-P"};